import { render, staticRenderFns } from "./CompanySecretary.vue?vue&type=template&id=544a7896&scoped=true&"
import script from "./CompanySecretary.vue?vue&type=script&lang=js&"
export * from "./CompanySecretary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544a7896",
  null
  
)

export default component.exports